// LMCREATIONForm.js
import React, { useState, useMemo, useEffect } from "react";
import "./LMCREATIONForm.css";
import { useEtatGlobal } from "../../../EtatGlobal.js";
import LMCREATIONTableau from "./LMCREATIONTableau.js";
import TableauDynamique from "./HONOTableau.js";
import { User, Building2, ChevronDown, Check } from "lucide-react";
import { Input } from "../../../../components/ui/input.js";
import { Select } from "../../../../components/ui/select.js";
import { Textarea } from "../../../../components/ui/textArea.js";
import CabinetSelect from "../../components/CabinetSelect";
import SelectOuAutre from "../../components/SelectOuAutre";
import {
  FORME_SOCIALE_OPTIONS,
  CIVILITE_OPTIONS,
  ORGANISATION_COMPTABLE_OPTIONS,
} from "../../components/lmSelectOptions";

function LMCREATIONForm({
  handleInputChange,
  handleCheckboxChangeTabeleau,
  handleCheckboxChangeDevis,
  setDetailsMission,
  setDetailsHonoraire,
}) {
  const { formData, rows } = useEtatGlobal();
  const [visible, setVisible] = useState(false);
  const [visible1, setVisible1] = useState(true);

  const [isOpen, setIsOpen] = useState(true);
  // Initialisé depuis formData.champ_libre (global, persiste au-delà du
  // montage du formulaire) plutôt que toujours false : sans ça, revenir de
  // /Visuel remonte ce composant avec la case décochée alors que le texte
  // saisi est toujours là dans formData — juste caché.
  const [showTextarea, setShowTextarea] = useState(() => {
    const val = formData.champ_libre;
    return typeof val === "string" && val.trim() !== "";
  });

  const isValid = useMemo(() => {
    // liste des champs à vérifier
    const requiredFields = ["acticite_principale", "volumes_annuels"];

    // retourne true seulement si tous les champs sont remplis (non vides)
    return requiredFields.every((field) => {
      const value = formData[field];
      return (
        value !== " " && value !== null && value !== undefined && value !== ""
      );
    });
  }, [formData]);

  const isValidHonoraire = useMemo(() => {
    return rows.every(
      (row) =>
        typeof row.diligence === "string" &&
        row.diligence.trim() !== "" &&
        row.diligence !== " " &&
        row.diligence !== null
    );
  }, [rows]);

  useEffect(() => {
    if (isValid) {
      setDetailsMission(true);
    } else {
      setDetailsMission(false); // facultatif si tu veux réinitialiser quand invalide
    }
  }, [isValid, setDetailsMission]);

  useEffect(() => {
    if (isValidHonoraire) {
      setDetailsHonoraire(true);
    } else {
      setDetailsHonoraire(false); // facultatif si tu veux réinitialiser quand invalide
    }
  }, [isValidHonoraire, setDetailsHonoraire]);
  return (
    <div className="Container">
      <div>
        <div
          className="border-2 border-slate-200 rounded-xl bg-white overflow-hidden"
          style={{ padding: "10px" }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
            className="p-4 hover:bg-slate-50 transition-colors rounded-lg mb-5"
            onClick={() => setIsOpen(!isOpen)}
          >
            <div
              style={{
                display: "flex",
                gap: "25px",
                justifyContent: "center",
                alignItems: "center",
              }}
            >
              <div
                className={`w-10 h-10 rounded-lg flex items-center justify-center transition-colors ${
                  isValid
                    ? "bg-emerald-100 text-emerald-700"
                    : "bg-slate-100 text-slate-600"
                }`}
              >
                {isValid ? (
                  <Check className="w-5 h-5" />
                ) : (
                  <Building2 className="w-5 h-5" />
                )}
              </div>

              <h3
                className="font-semibold text-slate-800"
                style={{ margin: 0 }}
              >
                1. Votre entité
              </h3>
            </div>
            <ChevronDown
              className={`w-5 h-5 text-slate-400 transition-transform ${
                isOpen ? "rotate-180" : ""
              }`}
            />
          </div>
          {isOpen && (
            <div
              initial={{ opacity: 0 }}
              animate={{ opacity: 1 }}
              className="p-6 pt-0 space-y-6"
            >
              <div className="grid md:grid-cols-2 gap-6">
                <div className="space-y-4">
                  <div className="grid grid-cols-2 gap-4">
                    <div>
                      <label className="text-slate-600 mb-1 block text-xs">
                        Forme sociale
                      </label>
                      <SelectOuAutre
                        name="forme_sociale"
                        value={formData.forme_sociale}
                        onChange={handleInputChange}
                        options={FORME_SOCIALE_OPTIONS}
                      />
                    </div>
                    <div>
                      <label className="text-slate-600 mb-1 block text-xs">
                        Nom du client
                      </label>
                      <Input
                        type="text"
                        name="nom_client"
                        value={formData.nom_client}
                        onChange={handleInputChange}
                        required
                        className="bg-white border-slate-200 h-9 text-sm"
                      />
                    </div>
                    {/* <div
                    className="siret-search"
                    style={{
                      display: "flex",
                      gap: "20px",
                      alignItems: "center",
                    }}
                  >
                    <div>
                      <label>Recherche Siret</label>
                      <input
                        type="text"
                        name="NumSiret"
                        value={numSiret}
                        onChange={handleNumSiretChange}
                        required
                      />
                    </div>

                    <div
                      onClick={handleSearchSiret}
                      disabled={isLoading}
                      style={{
                        marginTop: "7.5%",
                        color: "white",
                        background: "#840040",
                        padding: "2px 7.5px",
                        borderRadius: "4px",
                        border: "none",
                        cursor: "pointer",
                      }}
                    >
                      {isLoading ? (
                        <div
                          style={{
                            color: "white",
                            width: "10px",
                            height: "10px",
                            border: "2px solid #ccc",
                            borderTop: "2px solid #007BFF",
                            borderRadius: "50%",
                            animation: "spin 1s linear infinite",
                          }}
                        />
                      ) : (
                        <IoSearchSharp size={12} />
                      )}
                    </div>
                  </div> */}
                  </div>
                  <CabinetSelect />
                  <div>
                    <label className="text-slate-600 mb-1 block text-xs">
                      Adresse
                    </label>
                    <Input
                      type="text"
                      name="adresse"
                      value={formData.adresse}
                      onChange={handleInputChange}
                      className="bg-white border-slate-200 h-9 text-sm"
                    />
                  </div>

                  <div className="grid grid-cols-3 gap-4">
                    <div>
                      <label className="text-slate-600 mb-1 block text-xs">
                        Activité Principale
                      </label>
                      <Input
                        type="text"
                        name="acticite_principale"
                        value={formData.acticite_principale}
                        onChange={handleInputChange}
                        className="bg-white border-slate-200 h-9 text-sm"
                      />
                    </div>
                    <div>
                      <label className="text-slate-600 mb-1 block text-xs">
                        Organisation comptable
                      </label>
                      <SelectOuAutre
                        name="organisation_comptable"
                        value={formData.organisation_comptable}
                        onChange={handleInputChange}
                        options={ORGANISATION_COMPTABLE_OPTIONS}
                      />
                    </div>
                    <div>
                      <label className="text-slate-600 mb-1 block text-xs">
                        Volumes annuels
                      </label>
                      <Input
                        type="text"
                        name="volumes_annuels"
                        value={formData.volumes_annuels}
                        onChange={handleInputChange}
                        className="bg-white border-slate-200 h-9 text-sm"
                      />
                    </div>
                  </div>

                  <div className="grid grid-cols-3 gap-4">
                    <div>
                      <label className="text-slate-600 mb-1 block text-xs">
                        Expert-Comptable
                      </label>
                      <Select
                        name="expert_comptable_nom"
                        value={formData.expert_comptable_nom}
                        onChange={handleInputChange}
                      >
                        <option value="Samuel HOARAU">Samuel HOARAU</option>
                        <option value="Anthony HOARAU">Anthony HOARAU</option>
                      </Select>
                    </div>
                    <div>
                      <label className="text-slate-600 mb-1 block text-xs">
                        Signataire
                      </label>
                      <Select
                        name="expert_comptable"
                        value={formData.expert_comptable}
                        onChange={handleInputChange}
                      >
                        <option value="Samuel HOARAU">Mrs Samuel HOARAU</option>
                        <option value="Anthony HOARAU">
                          Mrs Anthony HOARAU
                        </option>
                      </Select>
                    </div>
                    <div>
                      <label className="text-slate-600  block text-xs">
                        Information utiles{" "}
                      </label>
                      <Textarea
                        name="mission_complementaire"
                        value={formData.mission_complementaire}
                        placeholder=" - NEANT"
                        onChange={handleInputChange}
                        rows={1}
                      />
                    </div>
                  </div>
                  <div>
                    <div
                      style={{
                        marginBottom: "1px",
                        display: "flex",
                        gap: "10px",
                        alignItems: "center",
                      }}
                    >
                      <label className="text-slate-600 mb-1 block text-xs">
                        Ajouter un texte libre :
                      </label>
                      <Input
                        style={{ width: "5%" }}
                        type="checkbox"
                        checked={showTextarea}
                        onChange={(e) => {
                          const checked = e.target.checked;
                          setShowTextarea(checked);
                          // Décocher doit aussi vider champ_libre — sinon
                          // le texte saisi précédemment reste utilisé dans
                          // le document généré (texteFinal) même si la
                          // case n'est plus cochée et que rien n'est
                          // visible/saisi à l'écran.
                          if (!checked) {
                            handleInputChange({
                              target: { name: "champ_libre", value: "" },
                            });
                          }
                        }}
                        className="bg-white border-slate-200 h-4 text-sm"
                      />
                    </div>
                    {showTextarea && (
                      <Textarea
                        type="text"
                        name="champ_libre"
                        value={formData.champ_libre}
                        onChange={handleInputChange}
                        rows={3}
                      />
                    )}
                  </div>
                </div>

                <div className="bg-slate-50 rounded-xl p-4 border border-slate-200">
                  <h4 className="font-semibold text-slate-700 mb-5 text-sm flex items-center gap-2">
                    <User className="w-4 h-4 text-[#8B1D41]" />
                    Contact Référent
                  </h4>
                  <div className="space-y-3">
                    <div className="grid grid-cols-2 gap-3">
                      <div>
                        <label className="text-slate-600 mb-1 block text-xs">
                          Civilité
                        </label>
                        <SelectOuAutre
                          name="civilite_lm"
                          value={formData.civilite_lm}
                          onChange={handleInputChange}
                          options={CIVILITE_OPTIONS}
                        />
                      </div>
                      <div>
                        <label className="text-slate-600 mb-1 block text-xs">
                          Nom
                        </label>
                        <Input
                          type="text"
                          name="nom"
                          value={formData.nom}
                          onChange={handleInputChange}
                          className="bg-white border-slate-200 h-9 text-sm"
                        />
                      </div>
                    </div>
                    <div>
                      <label className="text-slate-600 mb-1 block text-xs">
                        Prénom
                      </label>
                      <Input
                        type="text"
                        name="prenom"
                        value={formData.prenom}
                        onChange={handleInputChange}
                        className="bg-white border-slate-200 h-9 text-sm"
                      />
                    </div>
                    <div>
                      <label className="text-slate-600 mb-1 block text-xs">
                        Email
                      </label>
                      <Input
                        type="email"
                        name="email"
                        value={formData.email}
                        onChange={handleInputChange}
                        className="bg-white border-slate-200 h-9 text-sm"
                      />
                    </div>
                    <div>
                      <label className="text-slate-600 mb-1 block text-xs">
                        Téléphone
                      </label>
                      <Input
                        type="text"
                        name="telephone"
                        value={formData.telephone}
                        onChange={handleInputChange}
                        className="bg-white border-slate-200 h-9 text-sm"
                      />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          )}
        </div>
        <br />
      </div>
      <div
        className="border-2 border-slate-200 rounded-xl bg-white overflow-hidden"
        style={{ padding: "10px" }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          className="p-4 hover:bg-slate-50 transition-colors rounded-lg mb-5"
          onClick={() => setVisible(!visible)}
        >
          <div
            style={{
              display: "flex",
              gap: "25px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="w-10 h-10 rounded-lg flex items-center justify-center transition-colors bg-slate-100 text-slate-600">
              <Building2 className="w-5 h-5" />
            </div>
            <h3 className="font-semibold text-slate-800" style={{ margin: 0 }}>
              2. NOTRE MISSION
            </h3>
          </div>
          <ChevronDown
            className={`w-5 h-5 text-slate-400 transition-transform ${
              visible ? "rotate-180" : ""
            }`}
          />
        </div>
        {visible && (
          <LMCREATIONTableau
            formData={formData}
            handleCheckboxChangeTabeleau={handleCheckboxChangeTabeleau}
            handleCheckboxChangeDevis={handleCheckboxChangeDevis}
          />
        )}
      </div>

      <br />

      <div
        className="border-2 border-slate-200 rounded-xl bg-white overflow-hidden"
        style={{ padding: "10px" }}
      >
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
          className="p-4 hover:bg-slate-50 transition-colors rounded-lg mb-5"
          onClick={() => setVisible1(!visible1)}
        >
          <div
            style={{
              display: "flex",
              gap: "25px",
              justifyContent: "center",
              alignItems: "center",
            }}
          >
            <div className="w-10 h-10 rounded-lg flex items-center justify-center transition-colors bg-slate-100 text-slate-600">
              <Building2 className="w-5 h-5" />
            </div>
            <h3 className="font-semibold text-slate-800" style={{ margin: 0 }}>
              Tableau Honoraires
            </h3>
          </div>
          <ChevronDown
            className={`w-5 h-5 text-slate-400 transition-transform ${
              visible1 ? "rotate-180" : ""
            }`}
          />
        </div>
        {visible1 && <TableauDynamique />}
      </div>

      <br />
    </div>
  );
}

export default LMCREATIONForm;
